import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useDrugStatusSchedule from "./hooks/useDrugStatusSchedule";

const DrugStatusSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectedSchedule,
}) => {
  const drugStatusScheduleData = useDrugStatusSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectedSchedule
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={drugStatusScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {drugStatusScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {drugStatusScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={drugStatusScheduleData.formFields}
        dropdownValues={drugStatusScheduleData.dropdownValues}
        paramsData={drugStatusScheduleData.paramsData}
        updataParamData={drugStatusScheduleData.updateParamData}
      />
      <ButtonsSection ctaButtons={drugStatusScheduleData.ctaButtons} />
      <DisplayTable
        data={drugStatusScheduleData.data}
        parmKey={drugStatusScheduleData.parmKey}
        menuOptions={drugStatusScheduleData.menuOptions}
        tableHeaders={drugStatusScheduleData.columnDef}
        setRowData={drugStatusScheduleData.setRowData}
        selectedPriceSchedules={drugStatusScheduleData.selectedRows}
        setSelectedPriceSchedules={drugStatusScheduleData.setSelectedRows}
        selectMode={selectMode}
        displayMode={selectMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={drugStatusScheduleData.first}
          rows={drugStatusScheduleData.rows}
          totalRecords={drugStatusScheduleData.totalRecords}
          currentPage={drugStatusScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={drugStatusScheduleData.onPageChange}
        />
      </div>
      {drugStatusScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={drugStatusScheduleData.isConfirmationModalOpen}
          onRequestClose={drugStatusScheduleData.closeConfirmationModal}
          onBack={drugStatusScheduleData.closeConfirmationModal}
          onSave={drugStatusScheduleData.deleteDrugStatus}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={drugStatusScheduleData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default DrugStatusSchedule;
